var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path 106",
    d: "M6.01675 5.82921L6.32887 5.78371L6.46835 5.50081L8.86153 0.646728L11.2547 5.50081L11.3941 5.78355L11.706 5.82917L17.1185 6.62074C17.1194 6.62237 17.1205 6.62513 17.1207 6.62902L17.1211 6.63666L17.1217 6.64428C17.1222 6.64998 17.1213 6.65546 17.1196 6.66009C17.1179 6.66469 17.1156 6.66764 17.114 6.66925L17.1126 6.67056L13.2119 10.4746L12.9862 10.6948L13.0395 11.0055L13.9584 16.3671L13.9604 16.3783L13.9615 16.3839L9.13667 13.8495L8.85734 13.7028L8.57815 13.8497L3.76264 16.3849C3.76268 16.3847 3.76273 16.3844 3.76278 16.3842L3.76437 16.3762L3.76574 16.3682L4.68472 11.0067L4.73798 10.696L4.51232 10.4758L0.612733 6.67176L0.612759 6.67173L0.607968 6.66716C0.606469 6.66573 0.604434 6.66318 0.602756 6.65922C0.601185 6.65552 0.600149 6.65108 0.600014 6.64626C0.600263 6.63613 0.602312 6.62655 0.605694 6.618L6.01675 5.82921Z",
    stroke: "black",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ae6e0a935170d1ac75ddeb6ef7f4798d.svg";
export { ForwardRef as ReactComponent };